export const browseCategories = [
  "Legal Translation",
  "Technical Translation",
  "Marketing Translation",
  "Financial Translation",
  "Website Translation",
  "Document translation",
].map((e, i) => {
  const image = require("./images/browse-categories/browse-category-" +
    (i + 1) +
    ".jpg");

  return {
    id: i,
    name: e,
    image: image,
  };
});

export const ourTranslators = [1, 2, 3].map((e, i) => {
  const image = require(`./images/our-translators/our-translator-${e}.png`);
  return {
    id: i,
    name: "mohameed ali",
    job: "Technical Translation",
    image: image,
    rate: e + 2,
  };
});

export const socialIcons = [
  {
    name: "facebook",
    url: "https://www.instagram.com/",
    icon: require(`./icons/social/instagram.svg`).default,
  },
  {
    name: "instagram",
    url: "https://www.facebook.com/",
    icon: require(`./icons/social/facebook.svg`).default,
  },
  {
    name: "twitter",
    url: "https://www.twitter.com/",
    icon: require(`./icons/social/twitter.svg`).default,
  },
  {
    name: "linkedin",
    url: "https://www.whatsapp.com/",
    icon: require(`./icons/social/whatsapp.svg`).default,
  },
  {
    name: "linkedin",
    url: "https://www.linkedin.com/",
    icon: require(`./icons/social/linkedin.svg`).default,
  },
];

export const paymentMethods = [
  require("./icons/payment_methods/mastercard.svg").default,
  require("./icons/payment_methods/jawwal_pay.svg").default,
  require("./icons/payment_methods/paypal.svg").default,
];
